export var ValidatorPosition;
(function (ValidatorPosition) {
    ValidatorPosition["formDialog"] = "validator_formDialog";
    ValidatorPosition["form"] = "validator_form";
    ValidatorPosition["filter"] = "validator_filter";
    ValidatorPosition["cnArrayTable"] = "validator_cnArrayTable";
    ValidatorPosition["cnArraySubAreaCard"] = "validator_cnArraySubAreaCard";
})(ValidatorPosition || (ValidatorPosition = {}));
